import { Injectable, signal, WritableSignal } from '@angular/core';
import Bowser from 'bowser';

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {

  private parser = Bowser.getParser(window.navigator.userAgent);

  browserSignal = signal<string>('');
  osSignal = signal<string>('');
  platformSignal = signal<string>('');

  getOsName(): string {
    return this.parser.getOSName();
  }

  getBrowserName(): string {
    return this.parser.getBrowserName();
  }

  getPlatformType(): string {
    return this.parser.getPlatformType(); // 'mobile', 'tablet', 'desktop', etc.
  }

  isMobile(): boolean {
    return this.getPlatformType() === 'mobile';
  }

  isTablet(): boolean {
    return this.getPlatformType() === 'tablet';
  }

  isDesktop(): boolean {
    return this.getPlatformType() === 'desktop';
  }
}
